import { useState } from 'react'
import { Button, Text, Textarea } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import { BOOKKEEPER_NOTE_MAX_LENGTH } from '../../lib/constants'

const PROMPT =
  "Anything you know that I don't: what the charge was for, who it was with, whether it was a one-off."
const PLACEHOLDER = 'Anything that helps place this charge'
const HELPER = 'Goes over with everything else you flag.'

interface BookkeeperHandOffProps {
  disabled: boolean
  saving: boolean
  onSend: (note: string) => void
  onBack: () => void
  prompt?: string
  placeholder?: string
  helper?: string
}

export const BookkeeperHandOff = ({
  disabled,
  saving,
  onSend,
  onBack,
  prompt = PROMPT,
  placeholder = PLACEHOLDER,
  helper = HELPER,
}: BookkeeperHandOffProps) => {
  const [note, setNote] = useState('')
  const locked = disabled || saving
  const sendable = note.trim() !== ''

  return (
    <div className="@container flex flex-col gap-3">
      {prompt && (
        <Text variant={TypographyStyles.LABEL_SM} color={TextColors.HEADER}>
          {prompt}
        </Text>
      )}

      <Textarea
        aria-label="Note for the bookkeeper"
        placeholder={placeholder}
        className="body-sm"
        rows={3}
        maxLength={BOOKKEEPER_NOTE_MAX_LENGTH}
        value={note}
        disabled={locked}
        onChange={(event) => setNote(event.target.value)}
      />

      <div className="flex flex-col gap-2 @md:flex-row @md:items-center @md:gap-4">
        <div className="flex items-center gap-3">
          <Button
            size="sm"
            variant="primary"
            className="shrink-0"
            disabled={locked || !sendable}
            loading={saving}
            onClick={() => onSend(note.trim())}
          >
            Send to a bookkeeper
          </Button>
          <Button
            size="sm"
            variant="link"
            className="h-auto shrink-0 p-0"
            disabled={saving}
            onClick={onBack}
          >
            Back
          </Button>
        </div>
        {helper && (
          <Text variant={TypographyStyles.BODY_XS} color={TextColors.MUTED}>
            {helper}
          </Text>
        )}
      </div>
    </div>
  )
}
